/*@flow*/
import type { Element } from 'react';
import React from 'react';
import cx from 'classnames';
import SearchAddress from 'comps/SearchAddress';
import type { LocalsT, TextboxLocals } from 'lib/proforma/types';

export default ({
  onChange,
  attrs,
  path,
  label,
  value,
}: LocalsT & TextboxLocals): Element<'div'> => {
  return (
    <div
      className={cx(
        'form-group form-group-depth-2',
        `form-group-${path.join('-')}`
      )}
    >
      <label className="col-form-label">{label}</label>
      <SearchAddress
        name={attrs.name}
        address={value || ''}
        onChange={(v) => {
          onChange(v);
        }}
      />
    </div>
  );
};
